import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "support-content flex flex-column" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      textContent: _toDisplayString(_ctx.$t("SUPPORT.TITLE"))
    }, null, 8, _hoisted_2),
    _createElementVNode("p", {
      class: "mb",
      textContent: _toDisplayString(_ctx.$t("SUPPORT.TEXT"))
    }, null, 8, _hoisted_3),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      class: "mb roboto-slab flex flex-align-center",
      href: "tel: +31 (0) 30 - 686 02 11"
    }, [
      _createElementVNode("i", { class: "icons8-phone primary--text mr-05" }),
      _createTextVNode("+31 (0) 30 - 686 02 11")
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("a", {
      class: "roboto-slab flex flex-align-center",
      href: "mailto:info@robametals.com"
    }, [
      _createElementVNode("i", { class: "icons8-email-open primary--text mr-05" }),
      _createTextVNode("info@robametals.com")
    ], -1))
  ]))
}